import { Button, StatusBox } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type TProps = {
  onClose: () => void;
};

const AlertSuccess: React.FC<TProps> = ({ onClose }) => {
  return (
    <>
      <StatusBox
        type="success"
        title={<FormattedMessage id="alerts.success_title" />}
        description={
          <FormattedMessage
            id="alerts.success_copy_n"
            values={{
              // @ts-expect-error
              b: (ch) => <b>{ch}</b>,
            }}
          />
        }
      />
      <Button style={{ marginTop: 24 }} onClick={onClose}>
        Zavrieť
      </Button>
    </>
  );
};

export default AlertSuccess;
